import { uiNotify } from "../../actions";


export const MARCAS_LOADED = "MARCAS_LOADED";

export const getMarcas = (catalogId, categoryId) => (dispatch) => {

  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
  dispatch(uiNotify({ text: "Loading data..." }));

  if(!categoryId) categoryId = "*"
  if(!catalogId) catalogId = "*"

  const ES_URL = `/api/es/catalog/${catalogId}/${categoryId}`;
  const PT_URL = `/api/pt/catalog/${catalogId}/${categoryId}`;


  return fetch(language === "es_ES" ? ES_URL : PT_URL)
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "Catalog data loaded" }));

      return dispatch({
        type: MARCAS_LOADED,
        payload: {
          data: data.marcas,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};

